import { datadogLogs } from "@datadog/browser-logs";

const logger = datadogLogs.logger;
logger.setHandler(["console", "http"]);

export default logger;
